// extracted by mini-css-extract-plugin
export default {"table":"VersionInfoDialog_table__psmsv","tableRow":"VersionInfoDialog_tableRow__zooNK","tableCell":"VersionInfoDialog_tableCell__VSJcD","link":"VersionInfoDialog_link__qFRRM"};